import { g as __rest, b as __assign } from '../../../../../_tslib-7a01aab4.js';
import React from 'react';

var FooterColumn = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({ className: "pgc-footer-column ".concat(className) }, rest), children));
};

export { FooterColumn };
